import { Box, Button, Circle, Heading, Text, useTheme } from "@chakra-ui/react";
import React from "react";
import { FaCheck } from "react-icons/fa6";
export const openCM = () => {
    if (typeof window.Cookiebot === "object" && typeof window.Cookiebot.renew === "function") {
        window.Cookiebot.renew();
    }
};
export const ConsentBlock = (props) => {
    const { colors } = useTheme();
    return (React.createElement(Box, { p: 12, borderRadius: "3xl", bgGradient: "radial(cardBlue.400, cardBlue.600)", display: "flex", flexDirection: "column", alignItems: "center", gap: 8 },
        React.createElement(Circle, { size: 12, bg: "brand.500" },
            React.createElement(FaCheck, { color: colors.brand["900"], size: 25 })),
        React.createElement(Heading, { textAlign: "center", color: "white", maxW: "500px", size: "md" }, props.title),
        React.createElement(Text, { textAlign: "center", color: "white", maxW: "500px" }, props.description),
        React.createElement(Button, { onClick: props.action, whiteSpace: "normal", h: "auto", py: 8, colorScheme: "brand", size: ["lg", "xl"], variant: "base", boxShadow: "glow" }, "Datenschutzeinstellungen \u00F6ffnen")));
};
